import {
  Directive,
  Input,
  OnInit,
  ElementRef,
  Renderer2,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

interface AutoFocus {
  focus :boolean;
  scroll :boolean;
  isInit ?:boolean;
}

export enum Actions {
  FOCUS = 'focus',
  SCROLL = 'scroll',
}

@Directive({
  selector: '[lumAutofocus]',
})
export class AutofocusDirective implements OnInit, OnChanges {
  @Input()
  lumAutofocus :AutoFocus;

  @Output()
  setIsReloadEl = new EventEmitter<boolean>();

  constructor(
    private hostElement ?:ElementRef,
    private renderer ?:Renderer2,
  ) {}

  ngOnInit() :void {
    this.scroll();
  }

  ngOnChanges({ lumAutofocus } :SimpleChanges) :void {
    if (lumAutofocus.previousValue) {
      this.scroll();
    }
  }

  private scroll() :void {
    if (Object.keys(this.lumAutofocus).length > 0) {
      const onElement = this.renderer.selectRootElement(
        this.hostElement.nativeElement,
      );

      Object.keys(this.lumAutofocus).map((key) => {
        switch (key) {
          case Actions.FOCUS:
            onElement.focus();
            break;

          case Actions.SCROLL:
            if (this.lumAutofocus.scroll && this.lumAutofocus.isInit) {
              onElement.scrollIntoView({
                behavior: 'auto',
                block: 'center',
                inline: 'center',
              });
              this.setIsReloadEl.emit(false);
            }
            // if (this.lumAutofocus.isInit && this.lumAutofocus.scroll) {
            // 	onElement.scrollIntoView({
            // 		behavior: "auto",
            // 		block: "center",
            // 		inline: "center"
            // 	});
            // 	this.setIsReloadEl.emit(false);
            // }

            break;
          default:
            break;
        }
      });
    }
  }
}
